import Counter from "./Counter";

const stats = [
  {
    end: 349,
    suffix: "+",
    label: "STUDENTS TRAINED",
    color: "text-blue-600",
  },
  {
    end: 84,
    suffix: "%",
    label: "COMPLETION RATE",
    color: "text-amber-700",
  },
  {
    end: 69,
    suffix: "%",
    label: "PRACTICAL SESSIONS",
    color: "text-blue-600",
  },
];

export default function StatsSection() {
  return (
    <section className=" py-14">
      {/* bg-gradient-to-tr from-[#12105E] to-[#2621C4]  */}
      <div className="mx-auto lg:px-28 md:px-14 px-6">
        <div className="grid gap-6 grid-cols-1 md:grid-cols-3">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="flex flex-col items-center"
            >
              <Counter
                end={stat.end}
                suffix={stat.suffix}
                className={`text-4xl md:text-5xl font-black ${stat.color}`}
              />

              <p className="mt-2 text-[9px] font-medium tracking-[0.35em] text-gray-600">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
